export default __webpack_public_path__ + "static/media/img10.5fbe3664.jpeg";